import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      healthcareProvider: {},
   },
};

export const healthcareProviderTranslationKeys = createScopedTranslationKeys(translations.pl, 'healthcareProvider');
